<!--手机端研究院-->
<template>
  <div>
    <!--logo-->
    <div class='logo'>
      <img src='../../assets/images/logo.png'>
    </div>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="homePage">
        </el-tab-pane>
        <el-tab-pane label="主营业务" name="mainBusiness">
        </el-tab-pane>

        <el-tab-pane label="经典案例" name="case"></el-tab-pane>
        <el-tab-pane label="新闻中心" name="newsCenter"></el-tab-pane>
        <el-tab-pane label="研究院" name="researchInstitute">
          <div class='text'>
            <p class='ql-editor' v-html='tableData.instituteContent'></p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="关于埃文" name="avi">关于埃文</el-tab-pane>
      </el-tabs>
      <!--底部占位-->
      <div style='height: 80px;'>
      </div>
    </template>

    <!--底部选项卡-->
    <div class='bottom'>
      <ul>
        <li class='tab' @click="tabButton(1)">联系方式</li>
        <li class='tab' @click="tabButton(2)">加入低碳行业</li>
        <li class='tab' @click="tabButton(3)">合作网站</li>
      </ul>
      <p>企业节能减排与低碳发展综合解决方案提供商</p>
    </div>
  </div>
</template>

<script>
import { selectAboutEvan } from '@api/auth'
import 'quill/dist/quill.core.css'

export default {
  created () {
    this.selectAboutEvan()
  },
  data () {
    return {
      queryParams: {},
      activeName: 'researchInstitute',
      tableData: {
        instituteContent: ''
      }
    }
  },
  methods: {
    tabButton (raw) {
      if (raw === 1) {
        // 联系方式
        this.$router.push({
          path: '/mobileContacInformation',
          query: {}
        })
      } else if (raw === 2) {
        // 加入低碳
        this.$router.push({
          path: '/moblielowCarbonIndustry',
          query: {}
        })
      } else if (raw === 3) {
        // 合作伙伴
        this.$router.push({
          path: '/mobileCooperativePartner',
          query: {}
        })
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.$router.push({
          path: '/mobileIndex',
          query: {
          }
        })
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/mobileMainBusiness',
          query: {
          }
        })
      } else if (tab.name === 'case') {
        this.$router.push({
          path: '/mobileCase',
          query: {
          }
        })
      } else if (tab.name === 'researchInstitute') {
        this.$router.push({
          path: '/mobileResearchInstituter',
          query: {
          }
        })
      } else if (tab.name === 'avi') {
        this.$router.push({
          path: '/mobileAboutAvi',
          query: {
          }
        })
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/mobileNewsCenter',
          query: {
          }
        })
      }
    },

    /** 埃文简介 */
    selectAboutEvan () {
      let that = this
      selectAboutEvan(this.queryParams).then(res => {
        that.tableData.instituteContent = res.instituteContent
      })
    }
  }
}
</script>

<style lang="less" >
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}
//logo
.logo{
  img{
    width: 70%;
    display: block;
    margin:10px auto;
  }
}

//tabs样式
 .el-tabs__item {
  border: 1px solid #fff;
  background-color: #90bc4f;
  width: 33.33%;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  float: left;
  display: block;
  text-align: center;
}
 .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}
 .el-tabs__item.is-top:nth-child(7) {
  padding-left: 0px;
}
.videoPlayer {
  height: 300px;
  width: 200px;
  margin: 0 auto;
}
//底部选项卡
.bottom{
  background-color: #fff;
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
  .tab{
    width: 33.33%;
    float: left;
    text-align: center;
    background-color: #90bc4f;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
  p{
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color:#90bc4f;
  }
}
.el-tabs__item.is-active {
  color: #fff;
  background-color: #73b649;
}
::v-deep .el-tab-pane{
  height:620px;
}

img {
  width: 100%;
}
.text{
  width: 90%;
  margin: 0 auto;
}
//去掉tab下划线
::v-deep .el-tabs__active-bar {
  width: 0px !important;
}
</style>
